<template>
  <el-card shadow="always" class="trial_apply--accomplish">
    <el-row type="flex" justify="center" align="middle">
      <i class="tg-icon tg-icon-complete"></i>
    </el-row>
    <el-row type="flex" justify="center" align="middle" class="trial_apply--accomplish-title">
      <span class="text-success-dark">
        <strong>{{$t('page.member.trial.accomplish.title')}}</strong>
      </span>
    </el-row>
    <el-row type="flex" justify="center" align="middle" class="trial_apply--accomplish-content">
      <span>{{$t('page.member.trial.accomplish.content')}}</span>
    </el-row>
    <el-row type="flex" justify="center" align="middle">
      <span class="text-danger-dark">{{$t('page.member.trial.accomplish.note')}}</span>
    </el-row>

    <div class="trial_apply--accomplish-info">
      <el-row type="flex" justify="start" class="col-12">
        <template v-for="num in 2">
          <el-row class="col-6" :key="num" type="flex" justify="space-around" align="middle">
            <span>{{$t('page.member.trial.accomplish.url[' + (num - 1) + ']')}}</span>
            <span class="input-block text-info col-6">{{loginUrl[num - 1]}}</span>
          </el-row>
        </template>
      </el-row>
      <table class="tg-table">
        <thead>
          <tr>
            <th width="50%">{{$t('column.trial_name')}}</th>
            <th width="50%">{{$t('column.trial_pwd')}}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td width="50%" align="center">{{row.trial_name}}({{row.nickname}})</td>
            <td width="50%" align="center">aaa123</td>
          </tr>
        </tbody>
      </table>
      <el-row type="flex">
        <el-col :span="12" class="mb-5">
          <tg-document :title="$t('page.member.trial.accomplish.tip.title')" titleClass="col-8">
            <template v-for="num in 8">
              <tg-document-item
                :key="num"
                :num="num"
                :content="$t('page.member.trial.accomplish.tip.content[' + (num -1) + ']')"
              ></tg-document-item>
            </template>
          </tg-document>
        </el-col>
        <el-col :span="12" class="mb-5">
          <tg-document :title="$t('page.member.trial.tip.remind.title')">
            <template v-for="num in 2">
              <tg-document-item
                :key="num"
                :num="num"
                :content="$t('page.member.trial.tip.remind.content[' + (num -1) + ']')"
              ></tg-document-item>
            </template>
          </tg-document>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center" align="middle">
        <tg-button
          @click.native="handleCopy"
          round
          :classes="['tg-btn-prompt--confirm']"
        >{{$t('component.btn.copy')}}</tg-button>
      </el-row>
    </div>
  </el-card>
</template>

<script>
import TgDocument from "@/components/document/TgDocument";
import TgDocumentItem from "@/components/document/TgDocumentItem";
import TgButton from "@/components/button/TgButton";

export default {
  components: {
    TgDocument,
    TgDocumentItem,
    TgButton,
  },
  props: {
    row: Object,
  },
  data() {
    return {
      loginUrl: ["tg9000.net", "tg7000.net"],
    };
  },
  methods: {
    handleCopy() {
      this.copyTextToClipboard();
    },
    copyTextToClipboard() {
      var TextRange = document.createRange();
      let info = this.$el.querySelector(".trial_apply--accomplish-info");
      TextRange.selectNode(info);
      let sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(TextRange);
      document.execCommand("copy");
    },
  },
};
</script>